import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../../../messages';
import { BankWithdrawComponent } from './component/BankWithdraw';

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/fiat/$productCode/',
)({
  component: BankWithdraw,
});

function BankWithdraw() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const { withdrawProductData } = useSelector(
    (rootState: RootState) => rootState.funds,
  );

  const { productCode } = Route.useParams();

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/withdraw/fiat/${withdrawProductData.code}`}
      />
      <div className="px-6 py-4">
        <BankWithdrawComponent productCode={productCode} />
      </div>
    </>
  );
}
